// The app-wide refresh indicator: a thin bar along the bottom edge of the masthead while data already on
// screen is being re-read (state/refreshActivity.ts). It is absolutely positioned and always mounted, so
// showing or hiding it never moves the page. Screen readers hear about a refresh only when it is slow;
// routine reloads stay silent.
import { type RefreshActivity, refreshActivity, useRefreshActivity } from '../state/refreshActivity.ts';

export const SLOW_REFRESH_TEXT = 'Still updating. This is taking longer than usual.';

export function RefreshBar({ store = refreshActivity }: { store?: RefreshActivity }) {
  const { visible, slow } = useRefreshActivity(store);
  return (
    <div className="refresh-indicator">
      <span className="refresh-bar" data-state={visible ? 'active' : 'idle'} aria-hidden="true">
        <span className="refresh-bar-fill" />
      </span>
      <span className="visually-hidden" role="status" aria-live="polite" aria-atomic="true">{slow ? SLOW_REFRESH_TEXT : ''}</span>
    </div>
  );
}
